import * as yup from "yup";

export const RequestResetPasswordSchema = yup.object().shape({
  email: yup.string().email().required().label("Email Address"),
});
